<template>
  <el-aside class="aside-bar" width="219px">
    <div class="hi_icon">
      <template v-if="hasLogin">
        <a
          class="pointer text-theme"
          @click.prevent.stop="$router.push('/user/detail')"
        >{{this.$store.getters.nickname}}</a>
        <div class="u-text-right u-font-16">Welcome back.</div>
      </template>
      <template v-else>
        <span class="pointer text-theme">Welcome to manybo</span>
        <p class="u-text-right u-font-16">manybo.com</p>
      </template>
    </div>

    <asideInfo />
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex'
import asideInfo from './mixin/aside'
export default {
  methods: {
    logout() {
      this.$store.dispatch('user/LogOut').then(() => {
        //location.reload() // 为了重新实例化vue-router对象 避免bug
        // this.$router.push('/')//不用跳，路由守卫自动处理
      })
    },
  },

  computed: {
    ...mapGetters(['hasLogin']),
  },
  components: {
    asideInfo,
  },
}
</script>

<style lang="scss" scoped>
.aside-bar {
  background: url('../../assets/img/logo2.png') #f8f8f8 left top no-repeat;
  position: relative;
  padding: 300px 0 0 0;
  .hi_icon {
    position: absolute;
    top: 150px;
    left: 0;
    padding: 80px 0 0 0;
    width: 100%;
    overflow: hidden;
    font-style: italic;
    font-weight: lighter;
    text-align: center;
    background: url('../../assets/img/icon008.png') 150px 0px no-repeat;
    div {
      font-size: 12px;
      margin: 5px 10px 0 0;
      color: #ccc;
      text-align: right;
    }
  }
}
</style>
